import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  className = ''
}: PaginationProps) {
  if (totalPages <= 1) return null;
  // Generate page numbers to show
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first, last, and pages around current
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }
    return pages;
  };
  return <div className={`flex items-center justify-between px-4 py-3 bg-white border-t border-border sm:px-6 ${className}`} data-id="element-1075">
      <div className="flex justify-between flex-1 sm:hidden" data-id="element-1076">
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-text-secondary bg-white border border-border rounded-md hover:bg-surface disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1077">
          Previous
        </button>
        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-text-secondary bg-white border border-border rounded-md hover:bg-surface disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1078">
          Next
        </button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" data-id="element-1079">
        <div data-id="element-1080">
          <p className="text-sm text-text-secondary" data-id="element-1081">
            Showing page{' '}
            <span className="font-medium text-text-primary" data-id="element-1082">{currentPage}</span>{' '}
            of{' '}
            <span className="font-medium text-text-primary" data-id="element-1083">{totalPages}</span>
          </p>
        </div>
        <div data-id="element-1084">
          <nav className="inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination" data-id="element-1085">
            <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center px-2 py-2 text-text-tertiary bg-white border border-border rounded-l-md hover:bg-surface disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1086">
              <span className="sr-only" data-id="element-1087">Previous</span>
              <ChevronLeftIcon className="w-5 h-5" aria-hidden="true" data-id="element-1088" />
            </button>

            {getPageNumbers().map((page, index) => {
            if (page === '...') {
              return <span key={`ellipsis-${index}`} className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-text-secondary bg-white border border-border" data-id="element-1089">
                    ...
                  </span>;
            }
            const isCurrent = page === currentPage;
            return <button key={`page-${page}`} onClick={() => onPageChange(page as number)} aria-current={isCurrent ? 'page' : undefined} className={`relative inline-flex items-center px-4 py-2 text-sm font-medium border ${isCurrent ? 'z-10 bg-primary/5 border-primary text-primary' : 'bg-white border-border text-text-secondary hover:bg-surface'}`} data-id="element-1090">
                  {page}
                </button>;
          })}

            <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="relative inline-flex items-center px-2 py-2 text-text-tertiary bg-white border border-border rounded-r-md hover:bg-surface disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1091">
              <span className="sr-only" data-id="element-1092">Next</span>
              <ChevronRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-1093" />
            </button>
          </nav>
        </div>
      </div>
    </div>;
}